import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from 'yup'
import { forgotpasswordAction } from "../Redux/Action/Authaction";
import { useDispatch } from "react-redux";
export default function ForgotPassword() {
  const dispatch=useDispatch();
  const formik=useFormik({
    initialValues:{
      email:"",
     
    },
    validationSchema:Yup.object().shape({
      email:Yup.string().email().required('Email is required'),
     
    }),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit:(values)=>{
  
      dispatch(forgotpasswordAction(values))

    }
  })


  return (
    <div>
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="logo">
              <img src={require("../Assets/Images/Logo.svg").default} />
            </div>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row className="box-center">
          <Col lg={12} className="m-auto">
            <div className="login-cmn-box">
              <div className="login-box-inner-wrap">
                <h2 className="text-center">Forgot Password</h2>
                <Form onSubmit={formik.handleSubmit}>
                  <div className="form-set">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Email</Form.Label>
                      <Form.Control type="email" placeholder="Type Here" name="email" onBlur={formik.handleBlur}
                      onChange={formik.handleChange}

                      />
                       {formik.errors.email && <div className="errors">{formik.errors.email}</div>}
                    </Form.Group>
                  </div>
                  <button
                  
                    variant="primary"
                    type="submit"
                    className="submit"
                  >
                    Send OTP
                  </button>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
